class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => {
        animation.play();
      });
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop"
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define("header-menu", HeaderMenu);

document.addEventListener("DOMContentLoaded", () => {
  function updateHeight() {
    const announcementBar = document.querySelector(".utility-bar");
    const header = document.querySelector("sticky-header");
    let _height = 0;
    if (announcementBar) {
      _height += announcementBar.getBoundingClientRect().height;
    }
    if (header) {
      _height += header.getBoundingClientRect().height;
    }
  }
  window.addEventListener("resize", () => {});

  // New MegaMenu

  const menuItems = document.querySelectorAll(".collections-list__item");
  const menuContents = document.querySelectorAll(
    ".megamenu-content-left__product"
  );

  menuItems.forEach((item) => {
    item.addEventListener("mouseenter", function () {
      menuItems.forEach((el) => el.classList.remove("active"));

      this.classList.add("active");

      const dataMenuItem = this.getAttribute("data-menu-item");

      if (dataMenuItem) {
        menuContents.forEach((content) => content.classList.remove("active"));

        menuContents.forEach((content) => {
          if (content.getAttribute("data-menu-content") === dataMenuItem) {
            content.classList.add("active");
            const collectionLink = content.parentElement.nextElementSibling;
            collectionLink.classList.add("active");
            if (collectionLink) {
              const linkElement =
                collectionLink.querySelector(".collection-link");
              if (linkElement) {
                const activeCollectionLi = document.querySelector(
                  ".collections-list__item.active"
                );
                const activeCollectionLink = activeCollectionLi.querySelector(
                  ".collections-list__item-link"
                );
                const activeCollectionLinkText =
                  activeCollectionLi.querySelector("p").textContent;
                linkElement.textContent = `About ${activeCollectionLinkText} Collection`;
                linkElement.setAttribute(
                  "href",
                  activeCollectionLink.getAttribute("href")
                );
              }
            }
          }
        });
      } else {
        menuContents.forEach((content) => {
          content.classList.remove("active");

          const collectionLink = content.parentElement.nextElementSibling;
          if (collectionLink) {
            collectionLink.classList.remove("active");
            const linkElement =
              collectionLink.querySelector(".collection-link");
            if (linkElement) {
              linkElement.textContent = "";
              linkElement.removeAttribute("href");
            }
          }
        });
      }
    });
  });

  // PreventDefault link click

  const megaMenuLinks = document.querySelectorAll(
    ".collections-list__item[data-menu-item] .collections-list__item-link"
  );

  megaMenuLinks.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();
    });
  });
});

$(".toggle-megamenu").on("mouseenter", function () {
  $(this).find(".w-dropdown-list").addClass("w--open");
  $("body").addClass("overflow-hidden");
});
$(".toggle-megamenu").on("mouseleave", function () {
  $(this).find(".w-dropdown-list").removeClass("w--open");
  $("body").removeClass("overflow-hidden");
  const menuItems = document.querySelectorAll(".collections-list__item");
  const contentItems = document.querySelectorAll(
    ".megamenu-content-left__product"
  );

  menuItems.forEach((item) => {
    item.classList.remove("active");
  });

  contentItems.forEach((content) => {
    const collectionLink = content.parentElement.nextElementSibling;
    collectionLink.classList.remove("active");
    content.classList.remove("active");
  });
});